<template>
  <div class="references">
    <div
      class="references-item"
      v-for="(item, index) in data"
      :key="item.docId"
    >
      <span>[{{ index + 1 }}]</span>
      <span class="references-item__title">{{ item.title }}</span>
      <div class="references-item__url" @click="jump(item.url)">
        <span>{{ item.url }}</span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    data: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    jump(url) {
      window.open(url, "_blank");
    },
  },
};
</script>

<style lang="scss" scoped>
.references {
  margin-bottom: 4px;
  &-item {
    display: flex;
    align-items: center;
    margin-bottom: 4px;
    &:last-child {
      margin-bottom: 0px;
    }
    &__title {
      white-space: nowrap;
      color: #333;
      margin: 0px 4px;
    }
    &__url {
      cursor: pointer;
      color: #3159ff;
      white-space: nowrap;
      text-overflow: ellipsis;
      overflow: hidden;
    }
  }
}
</style>